import axios from "axios";
import Cookies from "js-cookie";

const axiosServer = axios.create({
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + Cookies.get("ap_t"),
  },
});

const getTokenFromCookie = () => {
  return Cookies.get("ap_t");
};

const clearSessionAndRedirect = () => {
  Cookies.remove("ap_t");
  Cookies.remove("dateLoged");

  if (typeof window !== "undefined") {
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("permissions");
    window.localStorage.removeItem("pda_history_id");
    window.localStorage.removeItem("store_id");
    window.localStorage.removeItem("store_name");
    window.localStorage.removeItem("stores");
    window.localStorage.removeItem("userID");
    window.localStorage.removeItem("username");
    window.localStorage.removeItem("firstVisitDone");

    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
  }
};

axiosServer.interceptors.request.use((config) => {
  const token = getTokenFromCookie();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

let isRefreshing = false;

axiosServer.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error?.config;

    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isRefreshing
    ) {
      originalRequest._retry = true;
      isRefreshing = true;

      try {
        clearSessionAndRedirect();
      } catch (refreshError) {
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export { axiosServer };
